interface AddFieldButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

export function AddFieldButton({ icon, label, onClick }: AddFieldButtonProps) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors cursor-pointer"
    >
      {icon}
      {label}
    </button>
  );
}
